<div *ngFor="let toasterConfig of toasterConfigs">
    <motif-toast
      [type]="toasterConfig?.type"
      [show]="toasterConfig?.show"
      [duration]="5000"
      (hidden)="logEvent()"
      >{{ toasterConfig?.message }}
    </motif-toast>
</div>
